import React, { Component } from "react";
import { SelectorTitleStyled, DescriptionStyled, IconStyled, SelectorItemTab, InfoWrapper } from "./styles/Styled";
import { withFocusable } from "../../../../services/visualLibraryService";
import { i18n } from "../../../../services/i18nService";
import { ICONS } from "../../../../pages/EditProfile/EditProfile";
import { CheckboxStyled } from "../../../../pages/AddProfile/styles/Styled";

class SelectItem extends Component {
  render() {
    const { focused, className, item, isKidsProfile } = this.props;
    return (
      <SelectorItemTab
        className={`${!item.disabled && focused ? className + " focused" : className}`}
        disabled={item.disabled}
        description={item.description}
      >
        <InfoWrapper>
          <SelectorTitleStyled>{item.title}</SelectorTitleStyled>
          {item.description && (
            <DescriptionStyled
              className={`${!item.disabled && focused ? " focused" : ""}`}
              focused={!item.disabled && focused}
            >
              {item.description}
            </DescriptionStyled>
          )}
        </InfoWrapper>
        {item.key === "kidsProfile" ? (
          <CheckboxStyled
            type="checkbox"
            checked={isKidsProfile}
            className={`${!item.disabled && focused ? className + " focused" : className}`}
            width="2.3rem"
            height="2.3rem"
            focussedBorder="black"
            borderUnset={false}
          />
        ) : (
          <IconStyled name={ICONS[i18n.getDirection()]} iconHeight={"2.1875rem"} iconWidth={"2.1875rem"} />
        )}
      </SelectorItemTab>
    );
  }
}

const SelectorItemFocus = withFocusable(SelectItem);

class ItemSelector extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedIndex: props.selectedIndex || 0,
      focusedCardIndex: 1
    };
    this.onSelected = this.onSelected.bind(this);
  }
  onSelected(item, index) {
    this.setState({
      selectedIndex: index
    });
    this.props.onItemSelected && this.props.onItemSelected(item);
  }
  onHover(index) {
    this.setState({
      selectedIndex: index
    });
  }

  render() {
    const { focusName, items } = this.props;
    return (
      <>
        {items.map((item, index) => {
          return (
            <SelectorItemFocus
              item={item}
              key={`item-${index}`}
              focusPath={`selectorItem_${index}_${focusName}`}
              className={this.props.selectedIndex !== null && this.state.selectedIndex === index ? "selected" : null}
              onEnterPress={item.disabled ? () => {} : () => this.onSelected(item, index)}
              onMouseUp={
                item.disabled
                  ? () => {}
                  : () => {
                      this.onSelected(item, index);
                    }
              }
              onMouseEnter={
                item.disabled
                  ? () => {}
                  : () => {
                      this.onHover(index);
                    }
              }
              focusedCardIndex={this.state.focusedCardIndex}
              isKidsProfile={this.props.isKidsProfile}
              onUp={item.disabled ? () => {} : () => this.props.onUp && this.props.onUp(index, focusName)}
            />
          );
        })}
      </>
    );
  }
}
export default ItemSelector;
